import type { Session } from "@supabase/supabase-js";

import { accountRoleForSession, type AccountRole } from "./account-role";

/**
 * Which console chrome a loading skeleton should draw (D-F2). The admin console
 * has no side navigation (a tab strip under a taller top bar and centred
 * content); the partner console shares the provider shell but has no refresh
 * row above its sections. The skeleton follows the session's resolved role so
 * the hand-over to the real chrome does not swap layouts.
 *
 * Where nothing is known yet (the session is still being resolved, or the role
 * claim is in conflict) the provider chrome is used, as the console itself
 * defaults to the provider view (`defaultViewFor`).
 */
export type ConsoleChrome = AccountRole;

export function consoleChromeForSession(session: Session | null): ConsoleChrome {
  return accountRoleForSession(session) ?? "provider";
}
